import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4325590a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4325590a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325590a",
  null
  
)

export default component.exports